import { Link as MuiLink, Paper, Typography, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'
import reactStringReplace from 'react-string-replace'

import { COMPLETE_URL_REGEX } from '~/constants'
import { getMessageColors } from '~/features/chatbot/components/message/utils'
import useIsPartner from '~/features/partners/hooks/useIsPartner'
import { EMessageSpeaker } from '~/models/features'
import { store } from '~/store'
import rem from '~/utils/ui'

type TProps = {
  speaker: EMessageSpeaker
  message: string
  isFirst: boolean
}

function Message({ speaker, message, isFirst }: TProps) {
  const chatbotLayout = store((state) => state.chatbot.layout)
  const theme = useTheme()
  const { userColor, botColor, userBackgroundColor, botBackgroundColor } =
    getMessageColors(chatbotLayout, theme)
  const isPartner = useIsPartner()
  const urlMatches = [...message.matchAll(COMPLETE_URL_REGEX)]
  return (
    <Paper
      elevation={3}
      sx={{
        borderRadius: `${rem(16)} ${rem(16)} ${speaker === EMessageSpeaker.user ? `0 ${rem(16)}` : `${rem(16)} 0`}`,
        p: 2,
        paddingBottom: isFirst && isPartner ? rem(23) : 2,
        width: 'fit-content',
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        maxWidth: '70%',
        alignSelf: speaker === EMessageSpeaker.user ? 'flex-end' : 'flex-start',
        color: speaker === EMessageSpeaker.user ? userColor : botColor,
        backgroundColor:
          speaker === EMessageSpeaker.user
            ? userBackgroundColor
            : botBackgroundColor,
      }}
    >
      <Typography variant="body1">
        {urlMatches.length
          ? urlMatches.map((matches) => {
              return reactStringReplace(message, matches[0], (match, index) => (
                <MuiLink
                  key={index}
                  component={Link}
                  to={
                    match.includes('https://') || match.includes('http://')
                      ? match
                      : `https://${match}`
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  {match}
                </MuiLink>
              ))
            })
          : message}
      </Typography>
    </Paper>
  )
}

export default Message
